"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        width: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        height: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    max-width: 200px;\n    max-height: 60px;\n\n    box-sizing: border-box;\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 ", "px;\n    background: linear-gradient(\n      -180deg,\n      rgb(251, 251, 251) 0%,\n      rgb(239, 239, 239) 100%\n    );\n    border-radius: ", "px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: ", ";\n    font-size: 16px !important;\n\n    & img,\n    & svg {\n      height: 80%;\n      width: auto;\n      min-height: 24px;\n      min-width: 24px;\n      margin-right: 8px;\n    }\n\n    & span {\n      color: rgb(45, 50, 59);\n      font-weight: bold;\n      letter-spacing: 0px;\n    }\n\n    ", "\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports["default"] = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      height = _ref.height,
      width = _ref.width;
  return styled_components_1.css(_templateObject2(), theme.spacing.unit, theme.border.radius.medium * 2, theme.shadows.boxShadow.downloadIcon, height && styled_components_1.css(_templateObject3(), height), width && styled_components_1.css(_templateObject4(), width));
});